import { datasourceTableIcon, exportTriggerIcon } from '@y42/feature/icons';

export type JobParentType = 'table' | 'trigger';

export const JobParentData: Record<
  JobParentType,
  {
    logo: string;
    displayName: {
      singular: string;
      plural: string;
    };
  }
> = {
  table: {
    logo: datasourceTableIcon,
    displayName: {
      singular: 'Table',
      plural: 'Tables',
    },
  },
  trigger: {
    logo: exportTriggerIcon,
    displayName: {
      singular: 'Trigger',
      plural: 'Triggers',
    },
  },
};
